<template>
    <div v-if="$user('npo_title')" class="choise-your-cause"
        :class="{ 'px30': ($store.state.loginActiveStep === 'card' || $store.state.loginActiveStep === 'provide' || $store.state.loginActiveStep === 'addCard') }">
        <div class="text-16 tracking-normal text-text text-left title-your-cause opacity-60">
            {{ $t("Your Cause") }}
        </div>
        <div class="cause-choice text-text text-20 text-left tracking-normal mb-7">
            {{ getLocalizationData($user('npo_title')) }}
        </div>
    </div>
</template>

<script>
import mixins from "../../config/mixins";
export default {
    name: "CauseChoice",
    mixins: [mixins.npos],
};
</script>
